import { useQuery } from '@tanstack/react-query';
import { opportunityApiConnect } from '../../../lib/api/opportunityApi.connect';
/**
 * Hook to fetch the amendment history chain for an opportunity.
 * Returns entries ordered oldest → newest (as returned by the backend).
 */ export function useOpportunityHistory(noticeId, enabled = true) {
    return useQuery({
        queryKey: [
            'opportunities',
            'history',
            noticeId
        ],
        queryFn: ()=>opportunityApiConnect.getOpportunityHistory(noticeId),
        enabled: !!noticeId && enabled,
        staleTime: 5 * 60 * 1000
    });
}
